export interface IUserExistRequest {
    Login: string;
    Email: string;
    UserName: string;
    Password: string;
}

export interface IUserExistRespose {
    [key: string]: any;
}